module.exports = __webpack_public_path__ + "static/media/error.8a5444b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.png
// module id = 846
// module chunks = 0